// Used for scrolling
window.scrolling = (scrollElement, scrollToElement, nOffset = null, callback = null) => {
    let offset = ((nOffset === null) ? -70 : nOffset);
    let scrollAmount = (((scrollToElement.offset().top + offset) - scrollElement.scrollTop()));
    scrollElement.animate({
        scrollTop: scrollAmount
    }, 2000, () => {
        if (callback !== null) {
            callback();
        }
    });
}
